import { useState } from "react";
import {
  DataTable,
  DataTableFilterMeta,
  DataTableStateEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import { useGetEventInterestQuery } from "../../store/services/events";
import { EventInterestUser } from "../../models/events";

interface EventInterestDTProps {
  eventId: number;
}

const interestDateBodyTemplate = (rowData: EventInterestUser) =>
  new Date(rowData.createdAt).toLocaleString();

const defaultEventInterestFilters: DataTableFilterMeta = {
  email: { value: null, matchMode: "contains" },
  lastName: { value: null, matchMode: "contains" },
  firstName: { value: null, matchMode: "contains" },
};

const getTextFilterValue = (
  filters: DataTableFilterMeta,
  field: string
): string | undefined => {
  const filterMeta = filters[field];

  if (!filterMeta) return undefined;

  if ("value" in filterMeta) {
    return typeof filterMeta.value === "string" ? filterMeta.value : undefined;
  }

  if ("constraints" in filterMeta) {
    const firstConstraint = filterMeta.constraints?.[0];
    return typeof firstConstraint?.value === "string"
      ? firstConstraint.value
      : undefined;
  }

  return undefined;
};

export const EventInterestDT = ({ eventId }: EventInterestDTProps) => {
  const [page, setPage] = useState<number>(0);
  const [rows, setRows] = useState<number>(5);
  const [filters, setFilters] = useState<DataTableFilterMeta>(
    defaultEventInterestFilters
  );

  const { data, isLoading } = useGetEventInterestQuery({
    id: eventId,
    page: page + 1,
    limit: rows,
    email: getTextFilterValue(filters, "email"),
    lastName: getTextFilterValue(filters, "lastName"),
    firstName: getTextFilterValue(filters, "firstName"),
  });

  return (
    <div className="mt-4">
      <DataTable
        value={data?.items ?? []}
        loading={isLoading}
        header={() => (
          <h1 className="text-2xl font-bold m-0 p-0">
            Usuarios interesados
          </h1>
        )}
        paginator
        lazy
        first={page * rows}
        rows={rows}
        totalRecords={data?.pagination.total ?? 0}
        rowsPerPageOptions={[5, 10, 25, 50]}
        onPage={(event) => {
          setPage(Math.floor(event.first / event.rows));
          setRows(event.rows);
        }}
        filters={filters}
        onFilter={(event: DataTableStateEvent) => {
          setFilters(event.filters);
          setPage(0);
        }}
        emptyMessage="Sin usuarios interesados"
        className="my-4"
        filterDisplay="row"
        dataKey="id"
      >
        <Column
          field="email"
          header="Email"
          filter
          filterPlaceholder="Buscar por email"
          showFilterMenu={false}
          filterMatchMode="contains"
        />
        <Column
          field="lastName"
          header="Apellido"
          filter
          filterPlaceholder="Buscar por apellido"
          showFilterMenu={false}
          filterMatchMode="contains"
        />
        <Column
          field="firstName"
          header="Nombre"
          filter
          filterPlaceholder="Buscar por nombre"
          showFilterMenu={false}
          filterMatchMode="contains"
        />
        <Column
          field="createdAt"
          header="Fecha de interés"
          body={interestDateBodyTemplate}
        />
      </DataTable>
    </div>
  );
};
